import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import _ from 'lodash';
import { currencyFormatter } from 'utils/formatter';
import moment from 'moment';

import PageWrapper from 'components/wrappers/pages/PageWrapper/PageWrapper';
import styles from './FeatureDetailTransactionModal.css';

class FeatureDetailTransactionModal extends Component {
  render() {
    const {
      onHide,
      showModal,
      featurePrice,
      outletList,
      featureName,
    } = this.props;

    if (!onHide || !showModal || !featurePrice || !outletList || !featureName)
      return <div />;

    return (
      <Modal
        onHide={onHide}
        show={showModal}
        dialogClassName={`${styles['feature-detail-transaction']} modal-dialog`}
      >
        <Modal.Body bsClass={styles['modal-wrapper']}>
          <div>
            <button type="button" className="close" onClick={onHide}>
              <span aria-hidden="true">&times;</span>
            </button>
            <h4>DETAIL TRANSACTION</h4>
            <hr />
            <div>
              <PageWrapper>
                <div className={styles['payment-container']}>
                  {featurePrice &&
                    outletList &&
                    _.map(outletList, outlet => {
                      if (outlet.is_paying) {
                        return (
                          <div
                            key={outlet.id}
                            className={`row ${styles['detail-wrapper']}`}
                          >
                            <div className={`col-md-12`}>
                              <div className="row">
                                <div className="col-md-12">{outlet.name}</div>
                              </div>
                              <div className="row">
                                <div className="col-md-6">{featureName}</div>
                                <div className="col-md-6">
                                  <span className={styles['right-span']}>
                                    {currencyFormatter(
                                      featurePrice[outlet.id].final_price
                                    )}
                                  </span>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-12">
                                  Prorated for period from
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-12">
                                  {moment(
                                    featurePrice[outlet.id].start_date
                                  ).format('DD/MM/YYYY')}{' '}
                                  -{' '}
                                  {moment(
                                    featurePrice[outlet.id].end_date
                                  ).format('DD/MM/YYYY')}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      }
                    })}
                </div>
              </PageWrapper>
            </div>
            <div className={`row ${styles['close-wrapper']}`}>
              <div className="col-md-12">
                <button
                  className="btn btn-default btn-large btn-block"
                  onClick={onHide}
                >
                  <strong>Close</strong>
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default FeatureDetailTransactionModal;
